import { render, staticRenderFns } from "./SuiteAppNavigator.vue?vue&type=template&id=11073d7c&"
import script from "./SuiteAppNavigator.vue?vue&type=script&lang=js&"
export * from "./SuiteAppNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports